import $ from 'jquery';
import Asyncview from 'shopify-asyncview';
import morphdom from 'morphdom';
import rimg from 'rimg-shopify';
import ModalContent from '../components/ModalContent';
import ModalView from '../components/ModalView';

// IE11 polyfill for Number.isNaN
Number.isNaN = Number.isNaN || (value => value !== value);

function saveSpecialInstructions() {
  const newNote = $('.cart-instructions textarea').val();
  Shopify.updateCartNote(newNote, () => {
    // empty function so that Shopify"s callback isn"t invoked
  });
}

export default class StaticCart {
  constructor({ el }) {
    this.$el = $(el);
    this.messages = JSON.parse($('[data-cart-messages]', this.$el).text());
    this.cartTable = el.querySelector('[data-cart-table]');
    this.totalPrice = el.querySelector('[data-cart-total-price]');
    this.cartDiscounts = el.querySelector('[data-cart-discounts]');
    this.updateShippingLabel = this.updateShippingLabel.bind(this);
    this._bindEvents();
    this.timeouts = [];
    this.updateTimeout = null;
    this.render();
  }

  _bindEvents() {
    this.events = [
      $('.cart-instructions textarea', this.$el).on('change.cart', event => saveSpecialInstructions(event)),
      $('.cart-item-upload', this.$el).on('click.cart', event => this.showFile(event)),
      $('[data-shipping-calc-submit]', this.$el).on('click.cart', () => this.calculateShipping()),
    ];

    this._bindCartItemEvents(this.$el);
  }

  _bindCartItemEvents(scope) {
    // these are added separately so they can be easily added after undoing an item removal
    this.events.push(
      $('.cart-item-quantity-display', scope).on('change.cart-item', event => this.updateQuantity(event)),
      $('.cart-item-decrease', scope).on('click.cart-item', event => this.updateQuantity(event)),
      $('.cart-item-increase', scope).on('click.cart-item', event => this.updateQuantity(event)),
      $('.cart-item-remove', scope).on('click.cart-item', event => this.updateQuantity(event)),
    );
  }

  _unbindCartItemEvents() {
    this.events.forEach($el => $el.off('.cart-item'));
  }

  _unbindEvents() {
    this.events.forEach($el => $el.off('.cart'));
    this._unbindCartItemEvents();
  }

  render() {
    this.section = window.sectionJSON;
    this.cartText = window.cartTextJSON;
    this.$shippingStrings = $('[data-shipping-calculator-strings]');

    if (this.$shippingStrings.length) {
      this.shippingCalculator();

      if (
        Shop.customerLoggedIn
        && Shop.customerAddress
        && Shop.customerAddress.country.length
        && Shop.customerAddress.zip.length
      ) {
        this.calculateShipping(true);
      }

      Shopify.onError = XMLHttpRequest => this.handleErrors(XMLHttpRequest);
    }

    // Re-initialize magic payment buttons on settings change in the theme editor
    if (window.Shopify && window.Shopify.designMode) {
      try {
        window.Shopify.StorefrontExpressButtons.initialize();
      } catch (error) {
        // do nothing
      }
    }
  }

  updateQuantity(e) {
    e.preventDefault();
    let newQuantity;
    const $productRow = $(e.target).parents('tr');
    const $productQuantity = $productRow.find('.cart-item-quantity-display');
    let oldQuantity = parseInt($productQuantity.val(), 10);
    oldQuantity = Number.isNaN(oldQuantity) ? 1 : oldQuantity;

    if ($(e.target).hasClass('cart-item-quantity-display')) {
      newQuantity = oldQuantity;
    } else if ($(e.target).hasClass('cart-item-increase')) {
      newQuantity = oldQuantity + 1;
    } else if ($(e.target).hasClass('cart-item-decrease')) {
      newQuantity = Math.max(oldQuantity - 1, 0);
    } else if ($(e.currentTarget).hasClass('cart-item-remove')) {
      newQuantity = 0;
    }

    const key = $productRow[0].dataset.lineItemKey;

    $productQuantity.val(newQuantity);

    // cancel any pending requests
    if (this.updateTimeout !== null) {
      clearTimeout(this.updateTimeout);
    }

    this.updateTimeout = setTimeout(() => {
      // Debounce qty change if clicked rapidly
      if (parseInt($productRow.find('.cart-item-quantity-display').val(), 10) !== newQuantity) {
        this.updateTimeout = null;
        return;
      }

      const thisTimeoutId = this.updateTimeout;
      window.Shopify.changeItem(key, newQuantity, (cart) => {
        // If another request is in progress, discard this update
        if (this.updateTimeout !== thisTimeoutId) {
          return;
        }
        if (cart.item_count === 0) {
          // reload to show empty cart state
          window.location.reload();
          return;
        }
        this.updateCart(cart, thisTimeoutId);
      });
    }, 300);
  }

  updateCart(cart, thisTimeoutId) {
    const cartCount = cart.item_count;
    $('.cart-item-count').text(cart.item_count);
    if (cartCount > 0) {
      $('.header-tools-cart').addClass('cart-has-content');
    } else {
      $('.header-tools-cart').removeClass('cart-has-content');
    }

    // Swap the cart contents to update discount labels.
    Asyncview.load(
      window.Theme.routes.cart_url,
      'ajax',
    )
      .done(({ options, html }) => {
        // If another request is in progress, discard this update
        if (this.updateTimeout !== thisTimeoutId) {
          return;
        }
        this._unbindCartItemEvents();

        // Inject new cart table contents
        const newTableContainer = document.createElement('div');
        newTableContainer.innerHTML = html.table;

        morphdom(
          this.cartTable,
          newTableContainer.querySelector('table'),
          {
            onBeforeElUpdated: (fromEl, toEl) => {
              // Skip images if src matches
              // - we don't want to reload lazy loaded images
              if (fromEl.tagName === 'IMG' && fromEl.src === toEl.src) {
                return false;
              }
              return true;
            },
          },
        );

        rimg.watch(this.cartTable);

        // Inject new cart level discounts
        this.cartDiscounts.innerHTML = html.discounts;

        // Update total
        this.totalPrice.innerHTML = options.totalPrice;

        this._bindCartItemEvents(this.$el);
      })
      .fail(() => window.location.reload());
  }

  showFile(e) {
    const file = $(e.target).data('file');

    if (file.match(/(jpg|jpeg|png|gif)/)) {
      const image = `<img alt='' src='${file}'>`;

      const modalContent = new ModalContent({
        title: $(e.target).prev().text(),
        message: image,
      });

      this.modalView = new ModalView({
        model: modalContent,
        el: $('.modal-wrapper'),
      });
    }
  }

  shippingCalculator() {
    Shopify.Cart.ShippingCalculator.show({
      submitButton: this.messages.shippingCalculatorSubmitButton,
      submitButtonDisabled: this.messages.shippingCalculatorDisabled,
      customerIsLoggedIn: Shop.customerLoggedIn,
      moneyFormat: Shop.moneyFormat,
    });

    const selectableOptions = $('.cart-shipping-calculator select');

    this.timeouts.push(
      setTimeout(() => selectableOptions.map((index, select) => this.updateShippingLabel(select)), 500),
    );

    $('.cart-shipping-calculator select').change(() => selectableOptions.map((index, select) => this.updateShippingLabel(select)));
  }

  calculateShipping(auto) {
    let shippingAddress;
    $('[data-shipping-calc-submit]').val(this.messages.shippingCalculatorDisabled);

    if (auto) {
      shippingAddress = Shop.customerAddress;
    } else {
      shippingAddress = {};
      shippingAddress.zip = $('.address-zip').val() || '';
      shippingAddress.country = $('.address-country').val() || '';
      shippingAddress.province = $('.address-province').val() || '';
    }

    const queryString = Object.keys(shippingAddress)
      .map(key => `${encodeURIComponent(`shipping_address[${key}]`)}=${encodeURIComponent(shippingAddress[key])}`)
      .join('&');

    $.ajax(`${window.Theme.routes.cart_url}/shipping_rates.json?${queryString}`, { dataType: 'json' })
      .fail(error => this._handleErrors(error.responseJSON || {}))
      .done(response => {
        const rates = response.shipping_rates;

        let address = `${shippingAddress.zip}, ${shippingAddress.province}, ${shippingAddress.country}`;
        if (!shippingAddress.province.length) {
          address = `${shippingAddress.zip}, ${shippingAddress.country}`;
        }
        if (!shippingAddress.zip.length) {
          address = `${shippingAddress.province}, ${shippingAddress.country}`;
        }
        if (!shippingAddress.province.length || !shippingAddress.zip.length) {
          address = shippingAddress.country;
        }

        const shippingCalculatorResponse = $('.cart-shipping-calculator-response');
        shippingCalculatorResponse.empty().append("<p class='shipping-calculator-response message'/><ul class='shipping-rates'/>");

        const ratesFeedback = $('.shipping-calculator-response');

        if (rates.length > 1) {
          const firstRate = Shopify.formatMoney(rates[0].price, Shop.moneyFormat);
          const feedback = this.messages.shippingCalculatorRates
            .replace('{{ address }}', address)
            .replace('{{ number_of_rates }}', rates.length)
            .replace('{{ rate }}', `<span class='money'>${firstRate}</span>`);
          ratesFeedback.html(feedback);
        } else if (rates.length === 1) {
          const rate = this.messages.shippingCalculatorRate.replace('{{ address }}', address);
          ratesFeedback.html(rate);
        } else {
          ratesFeedback.html(this.messages.shippingCalculatorNoRates);
        }

        rates.forEach((rate) => {
          const price = Shopify.formatMoney(rate.price, Shop.moneyFormat);
          const rateValues = this.messages.shippingCalculatorRateValues
            .replace('{{ rate_title }}', rate.name)
            .replace('{{ rate }}', `<span class='money'>${price}</span>`);
          $('.shipping-rates').append(`<li>${rateValues}</li>`);
        });

        $('[data-shipping-calc-submit]').val(this.messages.shippingCalculatorSubmitButton);
      });
  }

  handleErrors(errors) {
    let errorMessage = $.parseJSON(errors.responseText);
    errorMessage = this.messages.shippingCalculatorError.replace('{{ error_message }}', errorMessage.zip);
    $('.cart-shipping-calculator-response').html(`<p class='error'>${errorMessage}</p>`);
    $('[data-shipping-calc-submit]').val(this.messages.shippingCalculatorSubmitButton);
  }

  updateShippingLabel(select) {
    if (select) {
      const $select = $(select);
      let selectedOption = $select.find('option:selected').val();

      if (!selectedOption || (selectedOption === '---')) {
        selectedOption = $select.data('default');
        $select.val(selectedOption);
      }

      this.timeouts.push(setTimeout(() => {
        if ($select.attr('name') === 'address[country]') {
          this.updateShippingLabel($('#address_province'));
        }
      },
        1500));
    }
  }

  onSectionUnload() {
    this._unbindEvents();
    this.timeouts.forEach(timeout => clearTimeout(timeout));
  }
}
